export default __webpack_public_path__ + "62e062ffb1aa9a40611965004c50973a.svg";